import React from "react";

const ProgramLevels = () => {
  return (
    <section className="solutions-area pt-100 pb-70">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">
            <img src="/images/images/star-icon.png" alt="StarIcon" />
            Adaptive Learning
          </span>
          <h2>Coding programs </h2>
          {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p> */}
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-6">
            <div className="single-solutions-box">
              <div className="icon">
                <i className="flaticon-rocket"></i>
              </div>
              <h3>Junior</h3>
              <p>Great way to start for Grade 3 - 5 students</p>

              {/* <Link to="/service-details-two" className="view-details-btn">
                                View Details
                            </Link> */}
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-6">
            <div className="single-solutions-box">
              <div className="icon">
                <i className="flaticon-laptop"></i>
              </div>

              <h3>Senior</h3>
              <p>
                Great for students Grade 6+ or students with prior coding
                experience.
              </p>

              {/* <Link to="/service-details-two" className="view-details-btn">
                                View Details
                            </Link> */}
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-sm-3 offset-md-3">
            <div className="single-solutions-box">
              <div className="icon">
                <i className="flaticon-money"></i>
              </div>
              <h3>Leaders</h3>
              <p>For STEM1 students who complete Sr. Program only!</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramLevels;
